/**
 * https://www.jb51.net/article/162548.htm
 * 全局异常处理
 * @param {
 * } error 
 * @param {*} vm 
 */
const errorHandler = (error, vm, info) => {
 console.error('抛出全局异常')
 console.error(vm)
 console.error(error)
 console.error(info)
 window.eventBus.$emit('onError',"v1001", {"message": info});
}

let monitorWhiteScreenNode//监控白屏节点
let homeWhiteScreenNode//主页主白屏节点
let errorWhiteScreenNode//错误主白屏节点

window.addEventListener('error', function(e) {
monitorWhiteScreenNode = document.querySelector('#app')
const srcElement = e.srcElement;
if (srcElement === window) {
    console.log('全局错误：：：', e.message)
    window.eventBus.$emit('onError',"v1001", {"message": e.message});
} else {
    console.log('元素错误：：：', e.srcElement.tagName, e.srcElement.src)
    // window.eventBus.$emit('onError',"v1001", e.srcElement.tagName||e.srcElement.src);
}
if (!monitorWhiteScreenNode) {
    console.log('app白屏', e, e.srcElement)
    window.eventBus.$emit('onError',"v1001", {"message": e.srcElement});
}else {
    homeWhiteScreenNode = document.querySelector('#home');
    errorWhiteScreenNode = document.querySelector('#error-page');
}
if(monitorWhiteScreenNode) {
    if (!document.getElementById('#app')) {
    console.log('app白屏', e, e.srcElement)   
    window.eventBus.$emit('onError',"v1001", {"message": e.srcElement});         
    } else {
    let $el = document.getElementById('#app').firstChild.tagName
    let text = document.querySelector($el);
        console.log('初始化：error:::', text)
        window.eventBus.$emit('onError',"v1001", {"message": text});
    }
} else if(homeWhiteScreenNode) {
    if (!document.getElementById('#home')) {
    console.log('home页面白屏', e)
    window.eventBus.$emit('onError',"v1001", e);
    } else {
    let $el = document.getElementById('#home').firstChild.tagName
    let text = document.querySelector($el);
        console.log('home页面：error:::', text)
        window.eventBus.$emit('onError',"v1001", {"message": text});
    }
} else if(errorWhiteScreenNode) {
    if (!document.getElementById('#home')) {
    console.log('error页面白屏', e)
    window.eventBus.$emit('onError',"v1001", {"message": e});           
    } else {
    let $el = document.getElementById('#error-page').firstChild.tagName
    let text = document.querySelector($el);
        console.log('error页面：error:::', {"message": text})
        window.eventBus.$emit('onError',"v1001", {"message": text});
    }
}
}, true);

window.onerror = function(message, source, line, column, error) {
window.eventBus.$emit('onError',"v1001", {"message": message});
}




let GlobalError = {
 install: (Vue, options) => {
 /**
  * 全局异常处理
  * @param {
  * } error 
  * @param {*} vm 
  */
  Vue.config.errorHandler = errorHandler
  Vue.mixin({
   beforeCreate() {
    const methods = this.$options.methods || {}
    Object.keys(methods).forEach(key => {
     let fn = methods[key]
     this.$options.methods[key] = function (...args) {
      let ret = fn.apply(this, args)
      if (ret && typeof ret.then === 'function' && typeof ret.catch === "function") {
       return ret.catch(errorHandler)
      } else { // 默认错误处理
       return ret
      }
     }
    })
   }
  })
  Vue.prototype.$throw = errorHandler
 }
}
export default GlobalError